export const environment = {
  production: false,
  // host:'https://localhost:8843',
  host: 'https://heroes-api.app.kerrydev.com',
  client: 'https://heroes.app.kerrydev.com',
  sentry_dsn: '',
  FACEBOOK_APP_ID: '944070932695902',
  googleMapsApiKey: 'AIzaSyDPX_qqUjh_TCIyQMuSt8qiFWzGTMhlDVQ',
  googleMapsHomepageId: 'd21122f38dc886f0'
};
